import { CroppingPatternRiskChartModel } from "@agroyaar/sdk";

const persianMonths: Record<number, string> = {
  1: "فروردین",
  2: "اردیبهشت",
  3: "خرداد",
  4: "تیر",
  5: "مرداد",
  6: "شهریور",
  7: "مهر",
  8: "آبان",
  9: "آذر",
  10: "دی",
  11: "بهمن",
  12: "اسفند",
};

export const formatShowNumber = (number: number) => {
  const rounded = Number(number).toFixed(0);
  if (number < 0) {
    return rounded.replace("-", "") + "-";
  }
  return rounded;
};

export function mapRiskToChartData(risk: CroppingPatternRiskChartModel) {
  return risk.data
    .sort((a, b) => a.monthNumber - b.monthNumber)
    .map((d) => ({
      name: persianMonths[d.monthNumber],
      value: d.value,
    }));
}

export function makeChartTemperatureRiskTitle(
  risk: CroppingPatternRiskChartModel,
  cropName: string
) {
  const sign = risk.type === "ABOVE" ? "بالاتر" : "پایین‌تر";
  return `احتمال دماهای ${sign} از ${formatShowNumber(
    risk.threshold
  )} درجه سانتی‌گراد - ${cropName}`;
}

export function makeChartHumidityRiskTitle(
  risk: CroppingPatternRiskChartModel,
  cropName: string
) {
  const sign = risk.type === "ABOVE" ? "بالاتر" : "پایین‌تر";
  return `احتمال وقوع رطوبت ${sign} از ${formatShowNumber(
    risk.threshold
  )} درصد - ${cropName}`;
}
